import React from "react";
import { Theme } from "../../theme";

export const CloseIcon = ({ fill, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            fill={fill ? fill : Theme.colors.blue}
            width="13.302"
            height="13.3"
            viewBox="0 0 13.302 13.3"
        >
            <path
                d="M708.426,997.07l-5.323-5.4,5.16-5.232a.784.784,0,0,0-1.116-1.1L702,990.557l-5.146-5.217a.785.785,0,0,0-1.117,1.1l5.162,5.232-5.323,5.4a.785.785,0,0,0,.559,1.336.792.792,0,0,0,.559-.233L702,992.791l5.309,5.382a.785.785,0,0,0,1.117-1.1Z"
                transform="translate(-695.35 -985.106)"
            />
        </svg>
    );
};
